export const PROJECT_MANAGEMENT_APP = "ProjectManagement";

export class QuickFixMountError extends Error {
  constructor(message, data = {}) {
    super(message);
    this.name = "QuickFixMountError";
    this.data = data;
  }
}

export function quickFixPanelContexts(projectManagementConfigurationId) {
  if (!Number.isInteger(projectManagementConfigurationId) || projectManagementConfigurationId <= 0) {
    throw new QuickFixMountError(
      `The quick fix panel needs the ${PROJECT_MANAGEMENT_APP} Configuration this q3po install uses, `
      + `but the root app reported ${JSON.stringify(projectManagementConfigurationId)}. `
      + "Run App::install(\"Q3po\") so the ProjectManagement dependency is recorded.",
      { projectManagementConfigurationId },
    );
  }
  return {
    projectsConfig: { entityType: "Configuration", pk: { id: projectManagementConfigurationId }, appName: PROJECT_MANAGEMENT_APP },
  };
}

export function createProjectRejection(rejection) {
  if (!rejection || !Array.isArray(rejection.eventNames) || !rejection.eventNames.includes("CreateProject")) {
    return "";
  }
  const detail = rejection.detail ? ` — ${rejection.detail}` : "";
  return `The server did not create the task: ${rejection.message}${detail}`;
}

export const ROOT_BOOT_POLL_MS = 100;
export const ROOT_BOOT_TIMEOUT_MS = 30000;

export function waitForRootBoot(isBooted, { pollMs = ROOT_BOOT_POLL_MS, timeoutMs = ROOT_BOOT_TIMEOUT_MS, now = () => Date.now(), sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) } = {}) {
  const startedAt = now();
  const check = () => {
    if (isBooted()) {
      return Promise.resolve();
    }
    if (now() - startedAt >= timeoutMs) {
      const error = new Error(`quick fix: the q3po root app did not finish booting within ${timeoutMs}ms, so the quick fix panel cannot open`);
      console.error(error); // eslint-disable-line no-console
      return Promise.reject(error);
    }
    return sleep(pollMs).then(check);
  };
  return check();
}

